<template>
  <div class="fee-payment-wrapper py-4">
    <PageTitleBar
      parent="Institute Dashboard"
      title="Fee Payment"
      icon="fas fa-coins fa-2x mb-2 text-warning"
    />
    <b-container fluid class="mt-3" style="max-width: 80%;">
      <FeeDue />
    </b-container>
  </div>
</template>

<script>
import PageTitleBar from '@/components/templates/Dashboard/Institute/PageTitleBar.vue';
import FeeDue from './FeeDue.vue';

export default {
  name: "FeePayment",
  components: {
    PageTitleBar,
    FeeDue,
  },
};
</script>

<style scoped>
.fee-payment-wrapper {
  background-color: #fff;
  min-height: 100vh;
}
</style>
